import React, { useState } from 'react';
import './SubmissionSlide.css'

interface SubmissionSlideProps {
  submitQuiz: (name: string, email: string) => void
}

function SubmissionSlide({ submitQuiz }: SubmissionSlideProps) {

  const [name, setName] = useState("") 
  const [email, setEmail] = useState("") 

  const [error, setError] = useState<string | null>(null)

  const validateAndSubmitQuiz = () => {

    if (!name && !email) {
      setError("Please enter your name and a valid email.")
      return
    }

    // validate name field
    if (name) {
      setError(null)
    } else {
      setError("Please enter your name.")
      return
    }

    // validate email field
    if (isValidEmail(email)) {
      setError(null)
    } else {
      setError("Please enter a valid email.")
      return
    }

    submitQuiz(name, email)
  }

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  return (
    <div className="submission-slide slide">
      <h2>Get your personalized Empowered Mom Style results and tailored tips delivered straight to your inbox!</h2>
      <div className='submission-form'>
        <input placeholder='Your name...' className="submission-form-input" value={name} onChange={(event) => { setName(event.target.value) }} />
        <input placeholder='Your email...' className="submission-form-input" value={email} onChange={(event) => { setEmail(event.target.value) }} />
      </div>
      <p>We’ll also send you empowering tips to help you thrive as a working mom (you can unsubscribe anytime).</p>
      <button className='button' onClick={validateAndSubmitQuiz}>Submit</button>
      <p className='quiz-error-message'>{error && `${error}`}</p>
    </div>
  );
};

export default SubmissionSlide;